<template>
  <v-row>
    <v-dialog v-model="dialogActive" persistent width="600">
      <v-card>
        <v-card-title>
          {{
            $t(
              "components.dialogs.serviceProtocolImportDialog.importServiceProtocol"
            )
          }}</v-card-title
        >
        <v-card-text>
          <v-autocomplete
            autocomplete="off"
            v-model="itemToAddUUID"
            :label="
              $t('components.dialogs.serviceProtocolImportDialog.selectItem')
            "
            :items="itemOptions"
            :item-text="formattedItemName"
            item-value="uuid"
            :search-input.sync="itemSearch"
            color="primary"
            @input.native="loadItems($event, $data)"
            @change="addNewItem()"
            :filter="filterItemName"
            no-filter
          >
            <template v-slot:item="{ item }">
              <span>{{ formattedItemName(item) }}</span>
              <span class="flex-ml-auto" v-if="item.is_public"
                ><v-icon class="mx-2">mdi-account-multiple</v-icon
                >{{
                  $t(
                    "components.dialogs.serviceProtocolImportDialog.publicTemplate"
                  )
                }}</span
              >
            </template>
          </v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="onCancel()"
            data-cy="importServiceProtocolDialogCancelBtn"
            >{{
              $t("components.dialogs.serviceProtocolImportDialog.cancel")
            }}</v-btn
          >
          <v-btn color="primary" text @click="onImport()">{{
            $t("components.dialogs.serviceProtocolImportDialog.import")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import debounce from "@/plugins/debounce";
import api from "@/utils/api.js";
export default {
  props: ["dialog"],
  data: () => ({
    itemSearch: "",
    isEditView: false,
    itemToAddUUID: null,
    itemOptions: [],
    itemSelected: {},
    itemServiceProtocol: [],
  }),
  created() {
    this.loadItems(null, this);
  },
  computed: {
    dialogActive() {
      return this.dialog ? true : false;
    },
  },
  methods: {
    formattedItemName: (item) => {
      let name = item.vendor
        ? `${item.vendor.name} ${item.name} `
        : `${item.name} `;
      name += item.sku !== null ? `- (${item.sku})` : "";
      return name;
    },
    filterItemName: function (item, queryText, itemText) {
      let splitItemText = itemText.split(" ");
      let found = true;
      queryText.split(" ").forEach(function (searchWord) {
        if (
          !splitItemText.find(
            (word) =>
              word.toLowerCase().indexOf(searchWord.toLowerCase()) !== -1
          )
        ) {
          found = false;
        }
      });
      return found;
    },
    onImport() {
      this.itemServiceProtocol.forEach((element) => {
        delete element.uuid;
      });
      this.$emit("import", this.itemServiceProtocol);
    },
    onCancel() {
      this.$emit("import", false);
    },
    addNewItem() {
      this.loadItems(null, this);
      this.itemSelected = this.itemOptions.find(
        (item) => item.uuid === this.itemToAddUUID
      );
      this.itemServiceProtocol = this.itemSelected.crm_services;
    },
    loadItems: debounce((event, self) => {
      self.itemSearch = self.itemSearch ? self.itemSearch : "";
      api
        .getItemList({
          search: self.itemSearch,
          include_public: true,
          only_with_services: true,
        })
        .then((resp) => {
          self.itemOptions = resp.data.results;
        });
    }, 300),
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
